<template>
  <div v-if="!isMobile">
    <HuluCourseCarousel
      v-if="popularCourses && popularCourses.length"
      :courses="popularCourses"
      title="Popular Courses"
      icon="whatshot"
      route="popular"
      :windowWidth="windowWidth"
    />
    <HuluCourseCarousel
      v-if="newCourses && newCourses.length"
      :courses="newCourses"
      title="New Courses"
      icon="new_releases"
      route="new"
      :windowWidth="windowWidth"
    />
    <HuluCourseCarousel
      v-if="trendingCourses && trendingCourses.length"
      :courses="trendingCourses"
      title="Trending Courses"
      icon="show_chart"
      route="trending"
      :windowWidth="windowWidth"
    />
  </div>
  <div v-else>
    <MobileHuluCourseCarousel
      v-if="popularCourses && popularCourses.length"
      :courses="popularCourses"
      :presenters="presenters"
      title="Popular Courses"
      icon="whatshot"
      route="popular"
    />
    <MobileHuluCourseCarousel
      v-if="newCourses && newCourses.length"
      :courses="newCourses"
      :presenters="presenters"
      title="New Courses"
      icon="show_chart"
      route="new"
    />
    <MobileHuluCourseCarousel
      v-if="trendingCourses && trendingCourses.length"
      :courses="trendingCourses"
      :presenters="presenters"
      title="Trending Courses"
      icon="new_releases"
      route="trending"
    />
  </div>
</template>

<script>
import { lazyLoadComponent } from '@/helpers'
import LazyLoadingSpinner from '@/components/layout/LazyLoadingSpinner.vue'

export default {
  name: 'CarouselsByMetrics',
  components: {
    HuluCourseCarousel: lazyLoadComponent({
      componentFactory: () =>
        import('@/components/home-page/HuluCourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    MobileHuluCourseCarousel: lazyLoadComponent({
      componentFactory: () =>
        import('@/components/home-page/MobileHuluCourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
    windowWidth: {
      type: Number,
      required: true,
    },
    presenters: {
      type: Array,
      required: true,
    },
    popularCourses: {
      type: Array,
      required: true,
    },
    newCourses: {
      type: Array,
      required: true,
    },
    trendingCourses: {
      type: Array,
      required: true,
    },
  },
}
</script>
